module.exports = [
	{
		"age": "16",
		"thirtyDay": "84.41",
		"sixtyDay": "47.24",
		"ninetyDay": "32.62"
	},
	{
		"age": "17",
		"thirtyDay": "84.83",
		"sixtyDay": "47.77",
		"ninetyDay": "33.15"
	},
	{
		"age": "18",
		"thirtyDay": "85.24",
		"sixtyDay": "48.21",
		"ninetyDay": "33.7"
	},
	{
		"age": "19",
		"thirtyDay": "87.05",
		"sixtyDay": "49.38",
		"ninetyDay": "34.66"
	},
	{
		"age": "20",
		"thirtyDay": "89.66",
		"sixtyDay": "51.21",
		"ninetyDay": "36.16"
	},
	{
		"age": "21",
		"thirtyDay": "92.44",
		"sixtyDay": "53.04",
		"ninetyDay": "37.68"
	},
	{
		"age": "22",
		"thirtyDay": "95.9",
		"sixtyDay": "55.19",
		"ninetyDay": "39.39"
	},
	{
		"age": "23",
		"thirtyDay": "100.89",
		"sixtyDay": "58.3",
		"ninetyDay": "41.85"
	},
	{
		"age": "24",
		"thirtyDay": "105.76",
		"sixtyDay": "61.44",
		"ninetyDay": "44.34"
	},
	{
		"age": "25",
		"thirtyDay": "111.29",
		"sixtyDay": "64.89",
		"ninetyDay": "47.12"
	},
	{
		"age": "26",
		"thirtyDay": "116.85",
		"sixtyDay": "68.42",
		"ninetyDay": "49.93"
	},
	{
		"age": "27",
		"thirtyDay": "122.37",
		"sixtyDay": "71.97",
		"ninetyDay": "52.83"
	},
	{
		"age": "28",
		"thirtyDay": "128.76",
		"sixtyDay": "76.07",
		"ninetyDay": "56.16"
	},
	{
		"age": "29",
		"thirtyDay": "134.82",
		"sixtyDay": "80.04",
		"ninetyDay": "59.39"
	},
	{
		"age": "30",
		"thirtyDay": "141.36",
		"sixtyDay": "84.22",
		"ninetyDay": "62.73"
	},
	{
		"age": "31",
		"thirtyDay": "151.88",
		"sixtyDay": "90.79",
		"ninetyDay": "68"
	},
	{
		"age": "32",
		"thirtyDay": "162.56",
		"sixtyDay": "97.56",
		"ninetyDay": "73.26"
	},
	{
		"age": "33",
		"thirtyDay": "174.18",
		"sixtyDay": "104.87",
		"ninetyDay": "79.07"
	},
	{
		"age": "34",
		"thirtyDay": "186.53",
		"sixtyDay": "112.53",
		"ninetyDay": "85.2"
	},
	{
		"age": "35",
		"thirtyDay": "199.12",
		"sixtyDay": "120.48",
		"ninetyDay": "91.43"
	},
	{
		"age": "36",
		"thirtyDay": "211.04",
		"sixtyDay": "127.88",
		"ninetyDay": "97.35"
	},
	{
		"age": "37",
		"thirtyDay": "223.37",
		"sixtyDay": "135.65",
		"ninetyDay": "103.38"
	},
	{
		"age": "38",
		"thirtyDay": "235.98",
		"sixtyDay": "143.38",
		"ninetyDay": "109.51"
	},
	{
		"age": "39",
		"thirtyDay": "248.57",
		"sixtyDay": "151.23",
		"ninetyDay": "115.74"
	},
	{
		"age": "40",
		"thirtyDay": "261.2",
		"sixtyDay": "158.97",
		"ninetyDay": "121.77"
	},
	{
		"age": "41",
		"thirtyDay": "273.93",
		"sixtyDay": "166.82",
		"ninetyDay": "127.79"
	},
	{
		"age": "42",
		"thirtyDay": "287.1",
		"sixtyDay": "174.78",
		"ninetyDay": "134.01"
	},
	{
		"age": "43",
		"thirtyDay": "300",
		"sixtyDay": "182.64",
		"ninetyDay": "140.04"
	},
	{
		"age": "44",
		"thirtyDay": "312.74",
		"sixtyDay": "190.37",
		"ninetyDay": "145.95"
	},
	{
		"age": "45",
		"thirtyDay": "325.49",
		"sixtyDay": "198",
		"ninetyDay": "151.87"
	},
	{
		"age": "46",
		"thirtyDay": "340.17",
		"sixtyDay": "206.81",
		"ninetyDay": "158.54"
	},
	{
		"age": "47",
		"thirtyDay": "354.99",
		"sixtyDay": "215.75",
		"ninetyDay": "165.42"
	},
	{
		"age": "48",
		"thirtyDay": "370.36",
		"sixtyDay": "224.89",
		"ninetyDay": "172.3"
	},
	{
		"age": "49",
		"thirtyDay": "385.62",
		"sixtyDay": "234.03",
		"ninetyDay": "179.3"
	},
	{
		"age": "50",
		"thirtyDay": "401.69",
		"sixtyDay": "243.82",
		"ninetyDay": "186.73"
	},
	{
		"age": "51",
		"thirtyDay": "420.79",
		"sixtyDay": "255.33",
		"ninetyDay": "195.53"
	},
	{
		"age": "52",
		"thirtyDay": "440.06",
		"sixtyDay": "267.04",
		"ninetyDay": "204.66"
	},
	{
		"age": "53",
		"thirtyDay": "461.4",
		"sixtyDay": "280.06",
		"ninetyDay": "214.78"
	},
	{
		"age": "54",
		"thirtyDay": "483.72",
		"sixtyDay": "293.93",
		"ninetyDay": "225.64"
	},
	{
		"age": "55",
		"thirtyDay": "507.95",
		"sixtyDay": "309.11",
		"ninetyDay": "237.7"
	},
	{
		"age": "56",
		"thirtyDay": "534.28",
		"sixtyDay": "325.77",
		"ninetyDay": "251.13"
	},
	{
		"age": "57",
		"thirtyDay": "562.83",
		"sixtyDay": "344.15",
		"ninetyDay": "266.08"
	},
	{
		"age": "58",
		"thirtyDay": "594.27",
		"sixtyDay": "364.7",
		"ninetyDay": "283.06"
	},
	{
		"age": "59",
		"thirtyDay": "629.46",
		"sixtyDay": "388.04",
		"ninetyDay": "302.65"
	},
	{
		"age": "60",
		"thirtyDay": "621.85",
		"sixtyDay": "380.08",
		"ninetyDay": "293.17"
	},
	{
		"age": "61",
		"thirtyDay": "566.97",
		"sixtyDay": "345.76",
		"ninetyDay": "265.31"
	},
	{
		"age": "62",
		"thirtyDay": "524.73",
		"sixtyDay": "318.23",
		"ninetyDay": "241.56"
	},
	{
		"age": "63",
		"thirtyDay": "483.29",
		"sixtyDay": "287.46",
		"ninetyDay": "211.02"
	},
	{
		"age": "64",
		"thirtyDay": "341.84",
		"sixtyDay": "183.7",
		"ninetyDay": "111.01"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedFiveYear.json
// module id = 454
// module chunks = 0